import ReactGA from "react-ga4";

ReactGA.initialize('G-W2R0L3HFM5');

function GAProvider({ children }) {
	return children;
}

export default GAProvider;
